/**
 * Converts a string to Title Case
 * Capitalizes the first letter of each word, except for small words
 * (unless they're the first word)
 */
export function toTitleCase(text: string | null | undefined): string {
  if (!text) return ''
  
  // Words that should remain lowercase (unless they're the first word)
  const smallWords = ['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'from', 
    'in', 'into', 'nor', 'of', 'on', 'or', 'the', 'to', 'with', 'via']
  
  const words = text.trim().split(/\s+/)
  
  return words.map((word, index) => {
    // Always capitalize the first word
    if (index === 0) {
      return capitalizeFirst(word)
    }
    
    // Keep small words lowercase
    const lowerWord = word.toLowerCase()
    if (smallWords.includes(lowerWord)) {
      return lowerWord
    }
    
    // Capitalize other words
    return capitalizeFirst(word)
  }).join(' ')
}

/**
 * Capitalizes the first letter of a word while preserving the rest
 */
function capitalizeFirst(word: string): string {
  if (!word) return word
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
}




